/**
 * See java class with same name.
 */
export type ExportFilter = MockExportFilter & {
    id: number;
}

export function defaultExportFilterFile(): ExportFilterFile {
    return {
        exportType: ExportType.COMPANY,
        rowFilters: [],
        fields: [],
        filePrefix: "",
        sortBy: ""
    }
}

/**
 * See java class with same name.
 */
export type CreateExportFilterRequest = MockExportFilter;

export type MockExportFilter = {
    customer: string;
    files: ExportFilterFile[];
}

export function mockExportFilter(): MockExportFilter {
    return {
        customer: "",
        files: []
    }
}

export type ExportFilterFile = {
    exportType: ExportType;
    filePrefix: string;
    sortBy: string;
    fields: ExportFilterField[];
    rowFilters: ExportFilterRowFilter[];
};

export type ExportFilterField = {
    field: string;
};

export type ExportFilterRowFilter = {
    filterField: string;
    filterOnEquals: string;
    fieldsToKeep: ExportFilterField[];
};

export function defaultExportRowFilter(): ExportFilterRowFilter {
    return {
        fieldsToKeep: [],
        filterOnEquals: "",
        filterField: ""
    }
}

export enum ExportType {
    COMPANY = "COMPANY",
    COMPANY_GROUP = "COMPANY_GROUP",
    ANNUAL_REPORT_ORGNO = "ANNUAL_REPORT_ORGNO",
    EVENT = "EVENT",
    HISTORICAL_COMPANY_NAMES = "HISTORICAL_COMPANY_NAMES",
    SANCTION_COMPANY = "SANCTION_COMPANY",
    TRADING_PROHIBITION = "TRADING_PROHIBITION",
    BOARD_HISTORY = "BOARD_HISTORY",
    PAYROLL_TAX = "PAYROLL_TAX",
    COMPANY_FINANCIAL = "COMPANY_FINANCIAL",
    PTREG = "PTREG",
    COUNSELING_PROHIBITION = "COUNSELING_PROHIBITION",
    BENEFICIAL_OWNER_HISTORY = "BENEFICIAL_OWNER_HISTORY",
    COMPANY_ADDRESS = "COMPANY_ADDRESS",
}

/**
 * Returns an array of all ExportType options. Order is not guaranteed.
 */
export function ExportTypeAsList(): string[] {
    const types = [];
    for (const type in ExportType) {
        types.push(type)
    }
    return types;
}
